package com.smashvoter.state

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import com.smashvoter.state.AppState.generateEmails
import kotlinx.browser.localStorage

enum class Screen { LOGIN, PAIR, ONBOARDING, ADMIN, TRUST }

private const val ADMIN_EMAIL = "m.volkers@wearetriple.com"

/**
 * Placeholder list of "known" emails that skip onboarding and go straight to voting.
 * TODO: replace with a real check (e.g. a backend flag or dedicated API endpoint).
 */

private val knownExternalEmails = listOf(
    "rmbrals95@gmail.com",
)


private val knownEmails = generateEmails(
    listOf(
        "Bart.Stoop",
        "Maikel.Plukkel",
        "Jelle.Tanja",
        "Fabian.Knop",
        "Remy.deRuiter",
        "Koen.Volkers",
        "Olger.Alphenaar",
        "Mirko.Volkers",
        "Ruud.Brals",
        "Frank.Braam",
        "Bram.Zwart",
        "Jeroen.Flietstra",
        "Eva.Visser"
    )
) + knownExternalEmails


object AppState {
    var sessionId: String? by mutableStateOf(null)
        private set

    var email: String? by mutableStateOf(null)
        private set

    var currentScreen: Screen by mutableStateOf(Screen.LOGIN)

    /** Call once at app startup to restore a persisted session. */
    fun loadFromStorage() {
        val stored = localStorage.getItem(SESSION_KEY)
        if (stored != null) {
            sessionId = stored
            val localEmail = localStorage.getItem(EMAIL_KEY) ?: return
            email = localEmail
            currentScreen = screenForEmail(localEmail)
        }
    }

    /**
     * Called after a successful login.
     * Routes to [Screen.PAIR] for known emails, [Screen.ONBOARDING] for everyone else.
     */
    fun saveSession(token: String, userEmail: String) {
        sessionId = token
        email = userEmail
        localStorage.setItem(SESSION_KEY, token)
        localStorage.setItem(EMAIL_KEY, userEmail)
        currentScreen = screenForEmail(userEmail)
    }

    fun clearSession() {
        sessionId = null
        email = null
        localStorage.removeItem(SESSION_KEY)
        localStorage.removeItem(EMAIL_KEY)
        currentScreen = Screen.LOGIN
    }

    private fun isKnownEmail(email: String): Boolean = email.lowercase() in knownEmails

    private fun screenForEmail(email: String): Screen = when {
        email.lowercase() == ADMIN_EMAIL -> Screen.ADMIN
        isKnownEmail(email) -> Screen.PAIR
        else -> Screen.ONBOARDING
    }

    private const val SESSION_KEY = "smashvoter_session"
    private const val EMAIL_KEY = "smashvoter_email"

    fun generateEmails(names: List<String>, domain: String = "wearetriple.com"): List<String> {
        return names.flatMap { fullName ->
            val parts = fullName.lowercase().split(".")
            require(parts.size >= 2) { "Name must have at least First.Last format: $fullName" }

            val firstName = parts.first()
            // Join remaining segments so "Remy.de.Ruiter" → lastName = "de.ruiter"
            val lastName = parts.drop(1).joinToString("")

            listOf(
                "${firstName.first()}.$lastName@$domain",
                "$firstName.$lastName@$domain"
            )
        }
    }
}
